import type { TextField } from '@warp-ds/react';
import cn from 'classnames';
import type { ReactElement } from 'react';
import { BasicDatePicker, type RangeSelectionProps, type SingleSelectionProps } from 'shared/components/basicDatePicker/BasicDatePicker';
import { useBreakpoints } from 'shared/hooks/useBreakpoints';
import styles from './NewSearch.module.css';

export const NewSearchDatePickerWrapper = ({
    startDate,
    endDate,
    onDateChange,
    className,
    modalFooter,
    upperDateLimit,
    useRange,
    disabledDateRanges,
    children,
}: Omit<SingleSelectionProps, 'visibleMonths'> | Omit<RangeSelectionProps, 'visibleMonths'>) => {
    const isSmallScreen = useBreakpoints({ breakpoint: 'sm' });

    if (useRange) {
        return (
            <BasicDatePicker
                data-testid="newSearchDatePicker"
                className={cn(styles.FrontpageDatePicker, className)}
                onDateChange={onDateChange}
                startDate={startDate}
                endDate={endDate}
                useRange={true}
                visibleMonths={2}
                modalFooter={modalFooter}
                upperDateLimit={upperDateLimit}
                disabledDateRanges={disabledDateRanges}
                useAnchor={
                    isSmallScreen
                        ? {
                              title: 'Når vil du reise?',
                          }
                        : undefined
                }>
                {children as [ReactElement<typeof TextField>, ReactElement<typeof TextField>]}
            </BasicDatePicker>
        );
    }

    return (
        <BasicDatePicker
            className={cn(styles.FrontpageDatePicker, className)}
            onDateChange={onDateChange}
            startDate={startDate}
            useRange={false}
            visibleMonths={2}
            modalFooter={modalFooter}
            upperDateLimit={upperDateLimit}
            disabledDateRanges={disabledDateRanges}>
            {children as ReactElement<typeof TextField>}
        </BasicDatePicker>
    );
};
